import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { EnvironmentService } from '@proximus/ng-common';

@Injectable()
export class MyProximusAuthenticationCheckGuard implements CanActivate {
  constructor(private environmentService: EnvironmentService) {}

  canActivate(): boolean {
    if (this.environmentService.isSmoothAccess) {
      window.location.assign(
        window.location.href.replace('/smoothAccess', '/myproximus'),
      );
      return false;
    }
    return true;
  }
}
